import type { ApolloCache } from "@apollo/client/cache"

import { FloorCompleteFragment } from "entities/floors/graphql/fragments.generated"
import { readFloorCompleteFragment } from "entities/floors/lib/readFloorFragment"
import { ProjectCompleteFragment } from "entities/projects/graphql/fragments.generated"
import { readProjectCompleteFragment } from "entities/projects/lib/readProjectFragment"
import { RoomCompleteFragment } from "entities/rooms/graphql/fragments.generated"
import { readRoomCompleteFragment } from "entities/rooms/lib/readRoomFragment"

/**
 * Attempts to read a Project, Floor, or Room fragment from the cache.
 * Tries each type in order and returns the first one found.
 *
 * @param id - The ID of the parent entity
 * @param cache - Apollo cache instance
 * @returns The parent fragment (Project, Floor, or Room) or null if not found
 */
export function readProjectParentFragment(
  id: string,
  cache: ApolloCache<object>
):
  | ProjectCompleteFragment
  | FloorCompleteFragment
  | RoomCompleteFragment
  | null {
  const project = readProjectCompleteFragment(id, cache)
  if (project) {
    return project
  }

  const floor = readFloorCompleteFragment(id, cache)
  if (floor) {
    return floor
  }
  const room = readRoomCompleteFragment(id, cache)
  if (room) {
    return room
  }

  return null
}
